import React, { useState } from 'react';
import { Download, FileText } from 'lucide-react';
import { useAuth } from '../../context/authcontext';
import LegalService from '../../services/legal.service';
import { canSignBaa } from '../../utils/baaAccess';
import { describeApiError } from '../../utils/apiErrors';

/**
 * Signed BAA download (Phase 5; owner or admin). Shared by Organization Account and the
 * export-only /account/suspended page (Phase 13).
 */
const SignedBaaSection: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  if (!canSignBaa(user)) return null;

  const downloadSignedBaa = async () => {
    setLoading(true);
    setError('');
    try {
      const downloadUrl = await LegalService.getBaaDownloadUrl();
      window.location.assign(downloadUrl);
    } catch (err) {
      setError(describeApiError(err, 'Unable to download signed BAA'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section aria-labelledby="signed-baa-heading" className="bg-white rounded-xl border border-slate-200">
      <div className="px-3 sm:px-4 py-3 sm:py-4 border-b border-slate-200">
        <div className="flex items-center gap-2"><FileText size={17} className="text-slate-600" /><h2 id="signed-baa-heading" className="text-base font-semibold text-slate-900">Business Associate Agreement</h2></div>
        <p className="text-sm text-slate-500 mt-1">Download your organization&apos;s signed BAA.</p>
      </div>
      <div className="p-3 sm:p-4">
        <button type="button" disabled={loading} onClick={downloadSignedBaa} className="inline-flex items-center gap-2 rounded-md bg-slate-800 px-3 py-2 text-sm font-medium text-white hover:bg-slate-700 disabled:cursor-not-allowed disabled:opacity-50"><Download size={16} />{loading ? 'Preparing download...' : 'Download signed BAA PDF'}</button>
        {error && <p className="mt-3 text-sm text-red-700" role="alert">{error}</p>}
      </div>
    </section>
  );
};

export default SignedBaaSection;
